var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useMemo, useImperativeHandle } from "react";
import { createPortal } from "react-dom";
import { useQuerySelector } from "@travel/shared/hooks";
import { toCamelCase } from "@travel/shared/utils";
var TRAVEL_COMPONENT_CLASSNAME = "travel__component";
export var PortalQuerySelector = forwardRef(function PortalQuerySelector(_a, ref) {
    var selector = _a.selector, component = _a.component, _b = _a.attributes, attributes = _b === void 0 ? [] : _b, mutateNode = _a.mutateNode;
    var _c = __read(useQuerySelector(selector), 2), nodes = _c[0], query = _c[1].query;
    var travelNodes = useMemo(function () {
        var e_1, _a;
        var travelNodes = [];
        var _loop_1 = function (node) {
            if (!node.classList.contains(TRAVEL_COMPONENT_CLASSNAME)) {
                node.classList.add(TRAVEL_COMPONENT_CLASSNAME);
            }
            var nodeAttributes = attributes.reduce(function (acc, attribute) {
                var isTuple = Array.isArray(attribute);
                var name = isTuple ? attribute[0] : attribute;
                var parser = isTuple ? attribute[1] : null;
                var defaultValue = isTuple ? attribute[2] || null : null;
                var attributeKey = toCamelCase(name.replace("data-travel-", ""));
                var value = node.getAttribute(name);
                var parsedValue = value && parser ? parser(value) : value;
                var finalValue = parsedValue !== undefined && parsedValue !== null
                    ? parsedValue
                    : defaultValue;
                if (finalValue !== undefined && finalValue !== null) {
                    acc[attributeKey] = finalValue;
                }
                return acc;
            }, {});
            travelNodes.push({
                node: node,
                attributes: nodeAttributes,
            });
            mutateNode === null || mutateNode === void 0 ? void 0 : mutateNode(node, nodeAttributes);
        };
        try {
            for (var nodes_1 = __values(nodes), nodes_1_1 = nodes_1.next(); !nodes_1_1.done; nodes_1_1 = nodes_1.next()) {
                var node = nodes_1_1.value;
                _loop_1(node);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (nodes_1_1 && !nodes_1_1.done && (_a = nodes_1.return)) _a.call(nodes_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return travelNodes;
    }, [nodes]);
    useImperativeHandle(ref, function () {
        return {
            refresh: query,
        };
    }, []);
    return (_jsx(_Fragment, { children: travelNodes.map(function (_a) {
            var node = _a.node, attributes = _a.attributes;
            return createPortal((typeof component === "function"
                ? component(attributes)
                : component), node);
        }) }));
});
